export const selectInAppMessagesState = (state) => state.inAppMessages;

export const selectInAppMessages = (state) =>
  state.inAppMessages?.messages?.data;

export const selectInAppMessagesLoading = (state) =>
  state.inAppMessages?.messages?.loading;

export const selectInAppMessagesError = (state) =>
  state.inAppMessages?.messages?.error;

export const selectInAppMessagesPagination = (state) =>
  state.inAppMessages?.pagination;

export const selectUnseenMessagesCount = (state) =>
  state.inAppMessages?.unseenCount?.data;